<template>
    <div class="card mb-0">
        <div class="card-content">
            <div class="card-body">
                <h4>Savol turi: Maydonlarni to`ldirish</h4>
                <h4 class="d-flex align-items-start"><span v-html="question.question"></span></h4>
                <h4>Ответы: </h4>
                <div class="row">
                    <div class="table-responsive">
                        <table class="table table-hover table-bordered">
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Тип Ответа</th>
                                <th>Ответ</th>
                                <th>Балл</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(answer, index) in answers">
                                <td>{{ index + 1 }}</td>
                                <td>
                                    <span v-if="answer.answerTypeId === 1">Текст</span>
                                    <span v-else-if="answer.answerTypeId === 2">Число</span>
                                    <span v-else>Лист</span>
                                </td>
                                <td>
                                    <span v-if="answer.answerTypeId != 3">
                                        {{ answer.answers }}
                                    </span>
                                    <ul class="list-group" v-else>
                                        <li class="list-group-item"
                                            v-for="(ans, j) in answersList(answer.answers)">
                                            {{ j + 1 }}. {{ ans }}
                                        </li>
                                    </ul>
                                </td>
                                <td>
                                    {{ answer.ball }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <button class="btn btn-outline-primary waves-effect waves-light" data-dismiss="modal">
                        Назад
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FillingFieldModel",
        props: {
            question: Object,
            answers: Array
        },
        methods: {
            answersList(answers) {
                console.log(answers);
                let answersArr = answers.split(';');
                answersArr.pop();
                return answersArr;
            }
        },
        created() {

        }
    }

</script>

<style scoped>

</style>